/**
 * Query keys for notifications (`../core/keys.ts` is the convention). The
 * device registrations have no read, so they have no key.
 */
export const notificationKeys = {
    all: ["notifications"],
    preferences: ["notifications", "preferences"],
};
//# sourceMappingURL=keys.js.map